import styled from "styled-components";
import colors from "../../theme/color/ColorTheme";
import fontSize from "../../theme/fonts/FontTheme";

const InputWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Label = styled.span`
  color: #552d2d;
  font-size: ${fontSize.s};
  font-weight: 300;
`;

const Wrapper = styled.input`
  width: 100%;
  border: 1px solid ${colors.border};
  color: ${colors.black};
  font-size: ${fontSize.s};
  font-weight: 300;
  padding: 15px;
  border-radius: 8px;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border: 1px solid ${colors.black};
  }

  border-color: ${(props) => (props.invalid ? "red" : colors.border)};
`;

function DefaultInputBar({ placeholder, type, onChange, label, invalid }) {
  return (
    <InputWrapper>
      {label && <Label>{label}</Label>}
      <Wrapper
        placeholder={placeholder}
        type={type || "text"}
        onChange={onChange}
        invalid={invalid}
      />
    </InputWrapper>
  );
}

export default DefaultInputBar;
